import type { FormEvent, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'jw-territory-authenticated';
const PASSWORD = '1914';

function PasswordGate({ children }: PropsWithChildren) {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'true') {
      setIsAuthenticated(true);
    }
    setIsReady(true);
  }, []);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (input.trim() === PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setIsAuthenticated(true);
      setError('');
      setInput('');
      return;
    }
    setError('비밀번호가 올바르지 않습니다.');
    setInput('');
  };

  if (!isReady) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <div className="password-gate">
        <div className="password-gate__card">
          <h1 className="password-gate__title">보호된 페이지</h1>
          <p className="password-gate__description">
            접근하려면 비밀번호를 입력하세요.
          </p>
          <form className="password-gate__form" onSubmit={handleSubmit}>
            <input
              type="password"
              className="password-gate__input"
              value={input}
              placeholder="비밀번호"
              onChange={(event) => setInput(event.target.value)}
              autoFocus
            />
            <button type="submit" className="password-gate__button">
              확인
            </button>
          </form>
          {error ? <p className="password-gate__error">{error}</p> : null}
        </div>
        <style>{`
          .password-gate {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #0f172a, #1e293b);
            padding: 1.5rem;
            box-sizing: border-box;
          }
          .password-gate__card {
            width: 100%;
            max-width: 26rem;
            background: rgba(15, 23, 42, 0.9);
            border: 1px solid rgba(148, 163, 184, 0.2);
            border-radius: 0.75rem;
            padding: 2rem;
            box-shadow: 0 24px 56px rgba(15, 23, 42, 0.45);
            color: #e2e8f0;
          }
          .password-gate__title {
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 0.5rem;
            text-align: center;
          }
          .password-gate__description {
            font-size: 0.95rem;
            color: #cbd5f5;
            margin-bottom: 1.5rem;
            text-align: center;
          }
          .password-gate__form {
            display: grid;
            gap: 1rem;
          }
          .password-gate__input {
            width: 100%;
            padding: 0.75rem 1rem;
            border-radius: 0.5rem;
            border: 1px solid rgba(148, 163, 184, 0.4);
            background-color: rgba(15, 23, 42, 0.6);
            color: #e2e8f0;
            font-size: 1rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
          }
          .password-gate__input:focus {
            outline: none;
            border-color: #38bdf8;
            box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.25);
          }
          .password-gate__button {
            padding: 0.75rem 1rem;
            border-radius: 0.5rem;
            background: linear-gradient(135deg, #38bdf8, #0ea5e9);
            border: none;
            color: #0f172a;
            font-weight: 600;
            font-size: 1rem;
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .password-gate__button:hover {
            transform: translateY(-1px);
            box-shadow: 0 10px 20px rgba(14, 165, 233, 0.25);
          }
          .password-gate__button:active {
            transform: translateY(0);
          }
          .password-gate__error {
            margin-top: 0.5rem;
            font-size: 0.9rem;
            color: #fca5a5;
            text-align: center;
          }
        `}</style>
      </div>
    );
  }

  return <>{children}</>;
}

export default PasswordGate;
